module.exports = __webpack_public_path__ + "static/fonts/webhostinghub-glyphs.f015f8b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/webhostinghub-glyphs.ttf
// module id = 595
// module chunks = 0